/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseShapeIcon20Regular = forwardRef('MediaUiAPauseShapeIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.5 3A1.5 1.5 0 0 0 4 4.5v11A1.5 1.5 0 0 0 5.5 17h2A1.5 1.5 0 0 0 9 15.5v-11A1.5 1.5 0 0 0 7.5 3h-2Zm0 1.5h2v11h-2v-11Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 3A1.5 1.5 0 0 0 11 4.5v11a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 14.5 3h-2Zm0 1.5h2v11h-2v-11Z" })));
});
